import {NgModule} from "@angular/core";
import {LangManagerComponent} from "./lang-manager/lang-manager.component";
import {CommonModule} from "@angular/common";
import {MatMenuModule} from "@angular/material/menu";
import {TranslatePipe} from "@ngx-translate/core";
import {MatButtonModule} from "@angular/material/button";

@NgModule({
  declarations: [
    LangManagerComponent
  ],
  imports: [
    CommonModule,
    MatMenuModule,
    TranslatePipe,
    MatButtonModule
  ],
  exports: [
    LangManagerComponent
  ]
})
export class LanguageManagerModule {}
